var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: { title: _vm.pageTitle, backUrl: "/market/activity/apply/list" },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "applyForm",
              attrs: {
                model: _vm.applyForm,
                rules: _vm.applyRules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称", prop: "activityId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.isEdit,
                                placeholder: "请选择活动",
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.handleActivityChange },
                              model: {
                                value: _vm.applyForm.activityId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.applyForm, "activityId", $$v)
                                },
                                expression: "applyForm.activityId",
                              },
                            },
                            _vm._l(_vm.activityOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.activityName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.basicFormFields.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("基础信息")]
                      ),
                      _vm._l(_vm.basicFormFields, function (field) {
                        return _c(
                          "el-row",
                          {
                            key: _vm.getFieldName(field),
                            attrs: { gutter: 20 },
                          },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getFieldLabel(field),
                                      prop: _vm.getFieldName(field),
                                    },
                                  },
                                  [
                                    _vm.getFieldType(field) === "text" ||
                                    _vm.getFieldType(field) === "phone" ||
                                    _vm.getFieldType(field) === "idCard"
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入" +
                                              _vm.getFieldLabel(field),
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        })
                                      : _vm.getFieldType(field) === "textarea"
                                      ? _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 3,
                                            placeholder:
                                              "请输入" +
                                              _vm.getFieldLabel(field),
                                            maxlength: field.maxLength || 200,
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        })
                                      : _vm.getFieldType(field) === "select"
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder:
                                                "请选择" +
                                                _vm.getFieldLabel(field),
                                              clearable: "",
                                            },
                                            model: {
                                              value:
                                                _vm.applyForm[
                                                  _vm.getFieldName(field)
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.applyForm,
                                                  _vm.getFieldName(field),
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "applyForm[getFieldName(field)]",
                                            },
                                          },
                                          [
                                            _vm.getFieldName(field) ===
                                            "salesType"
                                              ? [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "美食",
                                                      value: 0,
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "文创",
                                                      value: 1,
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "游乐",
                                                      value: 2,
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "其他",
                                                      value: 3,
                                                    },
                                                  }),
                                                ]
                                              : _vm._l(
                                                  field.options,
                                                  function (option) {
                                                    return _c("el-option", {
                                                      key: option.value,
                                                      attrs: {
                                                        label: option.label,
                                                        value: option.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                          ],
                                          2
                                        )
                                      : _vm.getFieldType(field) === "radio"
                                      ? _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value:
                                                _vm.applyForm[
                                                  _vm.getFieldName(field)
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.applyForm,
                                                  _vm.getFieldName(field),
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "applyForm[getFieldName(field)]",
                                            },
                                          },
                                          _vm._l(
                                            field.options,
                                            function (option) {
                                              return _c(
                                                "el-radio",
                                                {
                                                  key: option.value,
                                                  attrs: {
                                                    label: option.value,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(option.label) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _vm.getFieldType(field) === "checkbox"
                                      ? _c(
                                          "el-checkbox-group",
                                          {
                                            model: {
                                              value:
                                                _vm.applyForm[
                                                  _vm.getFieldName(field)
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.applyForm,
                                                  _vm.getFieldName(field),
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "applyForm[getFieldName(field)]",
                                            },
                                          },
                                          _vm._l(
                                            field.options,
                                            function (option) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: option.value,
                                                  attrs: {
                                                    label: option.value,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(option.label) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _vm.getFieldType(field) === "number"
                                      ? _c("el-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            min: field.min || 0,
                                            max: field.max || 999999,
                                            precision: field.precision || 0,
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        })
                                      : _vm.getFieldType(field) === "date"
                                      ? _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "date",
                                            placeholder:
                                              "请选择" +
                                              _vm.getFieldLabel(field),
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        })
                                      : _vm.getFieldType(field) === "image"
                                      ? _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "image-upload-container",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "image-list" },
                                                [
                                                  _vm._l(
                                                    _vm.getImageList(field),
                                                    function (image, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "image-item",
                                                        },
                                                        [
                                                          _c("el-image", {
                                                            staticStyle: {
                                                              width: "100px",
                                                              height: "100px",
                                                              "border-radius":
                                                                "4px",
                                                            },
                                                            attrs: {
                                                              src: image,
                                                              fit: "cover",
                                                            },
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "image-actions",
                                                            },
                                                            [
                                                              _c("el-button", {
                                                                attrs: {
                                                                  type: "danger",
                                                                  size: "mini",
                                                                  icon: "el-icon-delete",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.removeImage(
                                                                        field,
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  _vm.getImageList(field)
                                                    .length < 9
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "image-upload-btn",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openImageModal(
                                                                field
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-plus",
                                                          }),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "upload-text",
                                                            },
                                                            [_vm._v("选择图片")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "upload-tip" },
                                                [
                                                  _vm._v(
                                                    "支持jpg、png格式，最多上传9张图片"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入" +
                                              _vm.getFieldLabel(field),
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.dynamicFormFields.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "el-divider",
                        { attrs: { "content-position": "left" } },
                        [_vm._v("活动要求填写信息")]
                      ),
                      _vm._l(_vm.dynamicFormFields, function (field) {
                        return _c(
                          "el-row",
                          {
                            key: _vm.getFieldName(field),
                            attrs: { gutter: 20 },
                          },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.getFieldLabel(field),
                                      prop: _vm.getFieldName(field),
                                    },
                                  },
                                  [
                                    _vm.getFieldType(field) === "text" ||
                                    _vm.getFieldType(field) === "phone" ||
                                    _vm.getFieldType(field) === "idCard"
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入" +
                                              _vm.getFieldLabel(field),
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        })
                                      : _vm.getFieldType(field) === "textarea"
                                      ? _c("el-input", {
                                          attrs: {
                                            type: "textarea",
                                            rows: 3,
                                            placeholder:
                                              "请输入" +
                                              _vm.getFieldLabel(field),
                                            maxlength: field.maxLength || 200,
                                            "show-word-limit": "",
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        })
                                      : _vm.getFieldType(field) === "select"
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              placeholder:
                                                "请选择" +
                                                _vm.getFieldLabel(field),
                                              clearable: "",
                                            },
                                            model: {
                                              value:
                                                _vm.applyForm[
                                                  _vm.getFieldName(field)
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.applyForm,
                                                  _vm.getFieldName(field),
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "applyForm[getFieldName(field)]",
                                            },
                                          },
                                          [
                                            _vm.getFieldName(field) ===
                                            "salesType"
                                              ? [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "美食",
                                                      value: 0,
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "文创",
                                                      value: 1,
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "游乐",
                                                      value: 2,
                                                    },
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: "其他",
                                                      value: 3,
                                                    },
                                                  }),
                                                ]
                                              : _vm._l(
                                                  field.options,
                                                  function (option) {
                                                    return _c("el-option", {
                                                      key: option.value,
                                                      attrs: {
                                                        label: option.label,
                                                        value: option.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                          ],
                                          2
                                        )
                                      : _vm.getFieldType(field) === "radio"
                                      ? _c(
                                          "el-radio-group",
                                          {
                                            model: {
                                              value:
                                                _vm.applyForm[
                                                  _vm.getFieldName(field)
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.applyForm,
                                                  _vm.getFieldName(field),
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "applyForm[getFieldName(field)]",
                                            },
                                          },
                                          _vm._l(
                                            field.options,
                                            function (option) {
                                              return _c(
                                                "el-radio",
                                                {
                                                  key: option.value,
                                                  attrs: {
                                                    label: option.value,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(option.label) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _vm.getFieldType(field) === "checkbox"
                                      ? _c(
                                          "el-checkbox-group",
                                          {
                                            model: {
                                              value:
                                                _vm.applyForm[
                                                  _vm.getFieldName(field)
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.applyForm,
                                                  _vm.getFieldName(field),
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "applyForm[getFieldName(field)]",
                                            },
                                          },
                                          _vm._l(
                                            field.options,
                                            function (option) {
                                              return _c(
                                                "el-checkbox",
                                                {
                                                  key: option.value,
                                                  attrs: {
                                                    label: option.value,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(option.label) +
                                                      " "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _vm.getFieldType(field) === "number"
                                      ? _c("el-input-number", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            min: field.min || 0,
                                            max: field.max || 999999,
                                            precision: field.precision || 0,
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        })
                                      : _vm.getFieldType(field) === "date"
                                      ? _c("el-date-picker", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            type: "date",
                                            placeholder:
                                              "请选择" +
                                              _vm.getFieldLabel(field),
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        })
                                      : _c("el-input", {
                                          attrs: {
                                            placeholder:
                                              "请输入" +
                                              _vm.getFieldLabel(field),
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.applyForm[
                                                _vm.getFieldName(field)
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.applyForm,
                                                _vm.getFieldName(field),
                                                $$v
                                              )
                                            },
                                            expression:
                                              "applyForm[getFieldName(field)]",
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "隐私政策", prop: "privacyStatus" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.privacyAgreed,
                        callback: function ($$v) {
                          _vm.privacyAgreed = $$v
                        },
                        expression: "privacyAgreed",
                      },
                    },
                    [
                      _vm._v(" 我已阅读并同意 "),
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showPrivacyPolicy },
                        },
                        [_vm._v("《隐私政策》")]
                      ),
                      _vm._v(" 和 "),
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showDisclaimer },
                        },
                        [_vm._v("《平台免责声明》")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.submitLoading },
                      on: { click: _vm.submitApply },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.isEdit ? "保存修改" : "提交报名") + " "
                      ),
                    ]
                  ),
                  _c("el-button", { on: { click: _vm.resetForm } }, [
                    _vm._v("重置"),
                  ]),
                  _c("el-button", { on: { click: _vm.goBack } }, [
                    _vm._v("返回"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "隐私政策",
            visible: _vm.privacyDialog,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.privacyDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "privacy-content" }, [
            _c("p", [
              _vm._v("我们非常重视您的隐私保护，以下是我们的隐私政策："),
            ]),
            _c("p", [
              _vm._v("1. 我们收集的信息：姓名、联系方式、身份证信息等必要信息"),
            ]),
            _c("p", [_vm._v("2. 信息使用：仅用于活动报名和联系目的")]),
            _c("p", [_vm._v("3. 信息保护：我们采用安全措施保护您的个人信息")]),
            _c("p", [
              _vm._v("4. 信息共享：未经您同意，我们不会向第三方分享您的信息"),
            ]),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "平台免责声明",
            visible: _vm.disclaimerDialog,
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.disclaimerDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "disclaimer-content" }, [
            _c("p", [_vm._v("平台免责声明：")]),
            _c("p", [_vm._v("1. 参与者需自行承担活动风险")]),
            _c("p", [_vm._v("2. 平台不对活动过程中的任何损失负责")]),
            _c("p", [_vm._v("3. 参与者需遵守相关法律法规")]),
            _c("p", [_vm._v("4. 平台保留活动解释权")]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }